import { Injectable } from '@angular/core';
import { Action } from '../model/action';
import { Clinic } from '../model/clinic';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';

@Injectable()
export class ClinicMasterService {
    http:HttpClientService;
    cookie : CookiesService;
    objAction : Action;
    data : Clinic;
    constructor(http : HttpClientService, cook : CookiesService) {
      this.http = http;
      this.cookie = cook;
      this.objAction  = new Action(this.http,  this.cookie);
    }
    
  saveClinic() : Observable<Clinic> {   
      this.objAction.header = null;
      this.objAction.data = this.data;
      this.objAction.path = 'api/Clinic/CreateClinic'
      return this.objAction.save();
   }
   updateClinic() : Observable<Clinic> {   
      this.objAction.header = null;
      this.objAction.data = this.data;
      this.objAction.path = 'api/Clinic/updateClinic'
      return this.objAction.update();
   }
   getClinic() : Observable<Clinic[]> {   
      this.objAction.path = 'api/Clinic/GetClinic'
      return this.objAction.get();
   }
   getClinicForOrganization(orgid : number) : Observable<Clinic[]> {   
    this.objAction.path = 'api/Clinic/GetOrgClinic?orgid='+ orgid;
    return this.objAction.get();
  }
   deleteClinic(objClinic : Clinic) : Observable<Clinic> {
      this.objAction.header = null;
      this.objAction.data = this.data;
      this.objAction.path = 'api/Clinic/DeleteClinic?strClinicId=' + objClinic.ClinicId; 
      return this.objAction.delete();
   }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/clinic-master.service.ts